import { render, staticRenderFns } from "./MonthlySocsoAffin.vue?vue&type=template&id=0f09108c"
import script from "./MonthlySocsoAffin.vue?vue&type=script&lang=js"
export * from "./MonthlySocsoAffin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports